import { setupUmbracoForms } from './modules/form';
setupUmbracoForms.init();

import polyfills from './global/polyfills';
polyfills.isNaN();
polyfills.entries();
polyfills.objectFit();

import initHelpers from './global/init-helpers';
initHelpers.init();

import cookieModal from './global/cookie-modal';
cookieModal.init();

import scroll from './global/scroll-top';
scroll.init();

import header from './global/header';
header.init();

import filters from './global/filters';
filters.init();

import search from './global/search';
search.init();

const scriptSections = document.querySelectorAll('[data-script]');
const scriptFileArray = [];
if (scriptSections.length > 0) {
	scriptSections.forEach((section) => {
		const fileName = section.dataset.script;
		if (scriptFileArray.includes(fileName)) return;
		scriptFileArray.push(fileName);
		import(`./modules/${fileName}`).then((mod) => {
			mod.default.init();
		});
	});
}

